const axios = require("axios");

var getDotDangKies = () => {
	return axios
		.get(`${process.env.VUE_APP_API}${process.env.VUE_APP_DOTDANGKY}`)
		.then((response) => response)
		.catch((error) => error.response);
};

var getDotDangKy = (dotDangKyId) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${
				process.env.VUE_APP_DOTDANGKY
			}/${dotDangKyId * 1}`,
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var getDotDangKyHocBaHT = () => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_DOTDANGKY}${process.env.VUE_APP_DKHOCBAHT}`,
		)
		.then((response) => response)
		.catch((error) => error.response);
};

var getLoaiDots = () => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_DOTDANGKY}${process.env.VUE_APP_LOAIDOT}`,
		)
		.then((response) => response)
		.catch((error) => error.response);
};

export const DotDangKySerVice = {
	getDotDangKies,
	getDotDangKy,
	getDotDangKyHocBaHT,
	getLoaiDots,
};
